import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ScrollToTop from "@/components/ScrollToTop";
import VisitTracker from "@/components/VisitTracker";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";

import Inicio from "@/pages/Inicio";
import QuienSoy from "@/pages/QuienSoy";
import ControlPrenatal from "@/pages/ControlPrenatal";
import SaludGinecologica from "@/pages/SaludGinecologica";
import AgendarCita from "@/pages/AgendarCita";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Shell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main className={isAdmin ? "pt-24 md:pt-28" : "pt-24 md:pt-28"}>
        {children}
      </main>
      {!isAdmin && <Footer />}
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <VisitTracker />
          <Shell>
            <Routes>
              <Route path="/" element={<Inicio />} />
              <Route path="/quien-soy" element={<QuienSoy />} />
              <Route path="/control-prenatal" element={<ControlPrenatal />} />
              <Route path="/salud-ginecologica" element={<SaludGinecologica />} />
              <Route path="/agendar" element={<AgendarCita />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Inicio />} />
            </Routes>
          </Shell>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{ classNames: { toast: "rounded-2xl border border-brand-silver" } }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
